import Dashboard from './Dashboard';

const Home = () => {
	return <Dashboard />;
};

export default Home;
